export default __webpack_public_path__ + "static/btweb-windows-screen-1a0111b1df462030336084f87ec843e0.png";